import React from 'react'
import PropTypes from "prop-types";

function GuldAnnons({ title, description, buttonText, buttonLink }) {
  return (
    <div className="container py-5" >
      <div className="row justify-content-center py-5">
        <div className='col-12 col-lg-6 px-2 px-md-0'>
          <h3 className='text-center text-md-left mb-3 n-md-h4'>{title}</h3>
          <p className='body2 text-center '>{description}</p>

          <div class="row justify-content-center" style={{ padding: '2rem 0rem' }}>
            <div className="col-md-8 col-12 text-center">
              <a href={buttonLink} target="_blank" rel="noopener noreferrer" className='n-btn btn-outline btn-sm btn-charcoal text-wrap w-100'>{buttonText}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

GuldAnnons.propTypes = {
  title: PropTypes.string,
  buttonLink: PropTypes.string,
  buttonText: PropTypes.string,
  description: PropTypes.string,
}

GuldAnnons.defaultProps = {
  title: undefined,
  buttonLink: undefined,
  buttonText: undefined,
  description: undefined,
};



export default GuldAnnons;